<template>
	<div class="navigation" :class="{ 'navigation--active': showMenu }">
		<button @click.stop="toggleMenu" class="responsive-menu"></button>
		<div class="navigation__top" @click.stop>
			<img src="/static/images/logo.png" alt="Logo CMS" class="navigation__logo" />
		</div>
		<nav class="nav" @click.stop v-if="user">
			<router-link class="nav__element" :to="{ name: 'home' }"><span class="nav__icon nav__icon--home"></span><span class="nav__text">Inicio</span></router-link>
			<router-link v-if="user.role <= 2" class="nav__element" :to="{ name: 'userView' }"><span class="nav__icon nav__icon--customers"></span><span class="nav__text">Usuarios</span></router-link>
			<router-link class="nav__element" :class="{ 'nav__element--active': inGalleries }" :to="{ name: 'galleryView' }"><span class="nav__icon nav__icon--customers"></span><span class="nav__text">Galerías</span></router-link>
			<router-link class="nav__element" :to="{ name: 'pagesView' }"><span class="nav__icon nav__icon--customers"></span><span class="nav__text">Páginas</span></router-link>
			<router-link class="nav__element" :class="{ 'nav__element--active': $route.name === 'inventoryView' }" :to="{ name: 'productView' }"><span class="nav__icon nav__icon--customers"></span><span class="nav__text">Productos</span></router-link>
			<router-link class="nav__element" :class="{ 'nav__element--active': $route.name === 'discountCupons' }" :to="{ name: 'discountCupons' }"><span class="nav__icon nav__icon--customers"></span><span class="nav__text">Cupones</span></router-link>
			<router-link class="nav__element" :class="{ 'nav__element--active': $route.name === 'freeShipping' }" :to="{ name: 'freeShipping' }"><span class="nav__icon nav__icon--customers"></span><span class="nav__text">Envíos Gratis</span></router-link>

			<router-link class="nav__element" :class="{ 'nav__element--active': $route.name === 'orders' }" :to="{ name: 'orders' }"><span class="nav__icon nav__icon--customers"></span><span class="nav__text">Órdenes</span></router-link>
			<router-link class="nav__element" :class="{ 'nav__element--active': $route.name === 'shoppingCarts' }" :to="{ name: 'shoppingCarts' }"><span class="nav__icon nav__icon--customers"></span><span class="nav__text">Carritos</span></router-link>
			<router-link class="nav__element" :to="{ name: 'mediaView' }"><span class="nav__icon nav__icon--customers"></span><span class="nav__text">Media</span></router-link>
		</nav>
	</div>
</template>

<script>
export default {
	data: function() {
		return {
			showMenu: false
		}
	},
	mounted: function() {
		window.addEventListener('click', () => {
			this.showMenu = false
		})
	},
	watch: {
		'$route.path': function() {
			this.showMenu = false
		}
	},
	methods: {
		toggleMenu: function() {
			this.showMenu = !this.showMenu
		}
	},
	computed: {
		user: function() {
			let user = null
			if (this.$store.state.user) {
				user = this.$store.state.user
			}
			return user
		},
		inGalleries: function() {
			return this.$route.name === 'galleryGroupsView' || this.$route.name === 'galleryImagesView'
		}
	}
}
</script>

<style lang="sass" scoped>
@import "../assets/sass/components/_nav"
</style>



// WEBPACK FOOTER //
// src/components/nav.vue